import {
	AuthorData,
	SeriesItemComponentData,
	SeriesItemData,
} from '../SeriesItemCardProps';
import { joinString } from '../../../../../../_helpers/join-string';

const getAuthors = (authorDataList: AuthorData[]): string => {
	return authorDataList?.map(({ authorName }) => authorName).join(',');
};

export const getAriaLabel = (
	itemData: SeriesItemData,
	componentData: SeriesItemComponentData,
	descriptionDisabled?: boolean
): string => {
	return joinString([
		componentData.ariaLabelPrefix,
		itemData.contentTitle,
		itemData.publicationDate,
		itemData.authors?.length ? componentData.writtenByLabel?.trim?.() : '',
		getAuthors(itemData.authors),
		descriptionDisabled ? '' : itemData.description,
	]);
};
